module.exports = __webpack_public_path__ + "static/media/allImpact_60yd_y-1.01bba591.csv";